module.exports = __webpack_public_path__ + "img/slider-10.acc08230.jpg";